/** Shown after the listing/card step is saved — guides user to the detail-page tab. */
export default function AdminDetailPrompt({ title, message, buttonLabel, onOpenDetail }) {
  return (
    <div className="admin-detail-prompt" role="status">
      <div className="admin-detail-prompt__icon" aria-hidden="true">
        ✓
      </div>
      <div className="admin-detail-prompt__body">
        <strong>{title}</strong>
        <p>{message}</p>
        <button type="button" className="admin-btn admin-btn--primary admin-btn--sm" onClick={onOpenDetail}>
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
